import { postData } from "../common/Apicall";

export const createPaymentOrderApi = (orderID, paymentAmount, providerID) => {
  return postData(`/api/v1/payment/createPaymentOrder`, {
    orderID,
    paymentAmount,
    providerID,
  });
};

export const paymentVerificationStatusApi = (
  razorpay_order_id,
  razorpay_payment_id,
  razorpay_signature,
  orderID,
  paymentAmount,
  providerID
) => {
  return postData(`/api/v1/payment/payment-verify`, {
    razorpay_order_id,
    razorpay_payment_id,
    razorpay_signature,
    orderID,
    paymentAmount,
    providerID,
  });
};

export const paymentFailedStatusApi = (
  razorpay_order_id,
  razorpay_payment_id
) => {
  return postData(`/api/v1/payment/payment-failed`, {
    razorpay_order_id,
    razorpay_payment_id,
  });
};

export const changeAccountTypeApi = () => {
  return postData("/api/v1/payment/updateAccountType");
};
